export default "__VITE_PUBLIC_ASSET__c3074a24__"